import { msg } from 'gt-react';
import { ChartBarIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const AdminReportsPage = lazyRouteComponent(
  () => import('../admin-reports/AdminReportsPage'),
  'AdminReportsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/reports',
  staticData: {
    app: {
      nav: {
        label: msg('Reports', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <ChartBarIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 50,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: AdminReportsPage,
  loader: () => ({
    crumb: msg('Reports', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
